import React from 'react';
import Spinner from 'react-spinkit';
import {connect} from "react-redux";
import {getUsers} from "../../actions/users";
import {Icon, Popover} from "antd";
import ContactCard from "./ContactCard";
import {compose} from "redux";
import {withLoading2} from "./deferLoaderHoc";
import PropTypes from 'prop-types';

class _UserSmall extends React.PureComponent {
  render() {
    const { resource: { id, firstName, lastName } } = this.props;
    if (!id) {
      return null;
    }
    return (
      <span>
        <Popover
          content={
            <ContactCard id={id}/>
          }
        >
          <span className='user-info-small'>
            <Icon type='idcard'/>
            {firstName} {lastName}
          </span>
        </Popover>
      </span>
    );
  }
}

const mapState = (state, ownProps) => {
  let user = state.users.data[ownProps.id];
  if (!user) { return { resource: { id: ownProps.id }, cache: { loading: true }}};
  return {
    resource: {
      id: ownProps.id,
      firstName: user.resource.firstname,
      lastName: user.resource.lastname,
    },
    cache: {
      loading: false
    }
  };
};

const UserSmall = compose(
  connect(mapState),
  withLoading2(
    ({ resource: { id } }, dispatch) => dispatch(getUsers(id)),
    () => <Spinner name='line-scale'/>,
    null,
    null,
    true
  )
)(_UserSmall);

UserSmall.propTypes = {
  id: PropTypes.string.isRequired
};

export default UserSmall;



// WEBPACK FOOTER //
// ./src/components/Boilerplate/UserSmall.js